module.exports = __webpack_public_path__ + "assets/img/accountConnectionImg_6.367fe0af.png";